import dayjs, { Dayjs, type QUnitType } from 'dayjs';

/** 생년월일(yyyy-MM-dd)이 만 14세 미만인지 (가입 연령 제한 판정) */
export const isUnderAge14 = (birthDate: string) =>
  dayjs().subtract(14, 'year').isBefore(dayjs(birthDate));

export const getRemainTime = (date: string) => {
  const current = dayjs();
  const target = dayjs(date);

  const dayDiff = target.diff(current, 'days');

  if (dayDiff > 8) return null;

  if (dayDiff > 0) {
    return `${dayDiff}일`;
  }

  const hourDiff = target.diff(current, 'hours');
  if (hourDiff > 0) {
    return `${hourDiff}시간`;
  }

  const minuteDiff = target.diff(current, 'minutes');
  if (minuteDiff > 0) {
    return `${minuteDiff}분`;
  }

  const secondDiff = target.diff(current, 'seconds');
  if (secondDiff > 0) return '1분';

  return null;
};
export const getRemainTimeUnit = (date: string) => {
  const current = dayjs();
  const target = dayjs(date);

  const dayDiff = target.diff(current, 'days');

  if (dayDiff > 8) return 'week' as const;

  if (dayDiff > 0) {
    return 'day' as const;
  }

  const hourDiff = target.diff(current, 'hours');
  if (hourDiff > 0) {
    // return `${hourDiff}시간`;
    return 'hour' as const;
  }

  const minuteDiff = target.diff(current, 'minutes');
  if (minuteDiff > 0) {
    return 'minute' as const;
  }

  const secondDiff = target.diff(current, 'seconds');
  if (secondDiff > 0) return 'second' as const;

  return null;
};

export const getHour = (timeStr?: string) => {
  const today = dayjs().format('YYYY-MM-DD'); // 오늘 날짜
  return dayjs(`${today} ${timeStr}`, 'YYYY-MM-DD HH:mm:ss');
};

export const getCurrentTimeDiff = (target: Dayjs, unit?: QUnitType) => {
  const today = dayjs();
  return today.diff(target, unit);
};

/** 현재 시각을 epoch(ms)로 반환. Date.now() 직접 호출 대신 사용해 테스트에서 mock 가능. */
export const getCurrentTime = () => dayjs().valueOf();

export const convertToDayJs = (date: string | Dayjs) => {
  if (typeof date === 'string') {
    return dayjs(date);
  }
  return date;
};

export const getToday = () => {
  return dayjs();
};
const DAY_OF_WEEK_TO_KOREAN = {
  0: '일',
  1: '월',
  2: '화',
  3: '수',
  4: '목',
  5: '금',
  6: '토',
};

export const getDayOfWeek = (date: string | Dayjs) => {
  const dayOfWeek = convertToDayJs(date).day();

  return DAY_OF_WEEK_TO_KOREAN[dayOfWeek];
};

export const formatDate = (date: string | Dayjs, template: string) => {
  const day = convertToDayJs(date);
  return day.format(template);
};

/**
 * - 현재 시간이 start와 end 사이에 있는지 확인
 */
export const isNowBetween = (start: string | Dayjs, end: string | Dayjs) => {
  const now = dayjs();
  return (
    now.isAfter(convertToDayJs(start)) && now.isBefore(convertToDayJs(end))
  );
};

/**
 * 제공 된 날짜가 내일 인지 검사하는지 확인
 * @param date
 */
export const isTomorrow = (date: string | Dayjs) => {
  const day = convertToDayJs(date);
  const diffTimes = getCurrentTimeDiff(day, 'days');
  // console.log('diffTimes', diffTimes);
  // return diffTimes < 24;
  return diffTimes === 0;
};
